var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.showHeader)?_c('agencyPageHeaderModule',{attrs:{"pageName":_vm.pageName,"menuIcon":_vm.iconUrl}}):_vm._e(),(_vm.showHeader)?_c('pageHeaderModule'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }